var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlockDs = function SvgUnlockDs(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.66667C10.6371 8.66667 9.81569 8.8425 9.0625 9.15583V6.16667C9.0625 4.78833 10.1561 3.66667 11.5 3.66667C12.8439 3.66667 13.9375 4.78833 13.9375 6.16667V7H15.5625V6.16667C15.5625 3.86583 13.7441 2 11.5 2C9.25506 2 7.4375 3.86583 7.4375 6.16667V10.1342C5.95306 11.3558 5 13.2292 5 15.3333C5 19.015 7.91037 22 11.5 22C15.0896 22 18 19.015 18 15.3333C18 11.6517 15.0896 8.66667 11.5 8.66667ZM11.5 17.0003C10.603 17.0003 9.875 16.2537 9.875 15.3337C9.875 14.4137 10.603 13.667 11.5 13.667C12.397 13.667 13.125 14.4137 13.125 15.3337C13.125 16.2537 12.397 17.0003 11.5 17.0003Z",
    fill: "#9496A9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlockDs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Unlock-ds.531dbc8ada5cb7a8ce62351490a95d99.svg";